import { useLayoutEffect, useRef } from 'react';
import { readHomeScroll, clearHomeScroll } from '@/utils/homeScroll';

/**
 * Restores the window scroll position saved by `saveHomeScroll` once content
 * is ready. Call `saveHomeScroll(scrollKey)` just before navigating away, then
 * mount this hook on the return page — it fires once per key when `isReady`
 * becomes true.
 */
export function useScrollRestore(scrollKey: string, isReady: boolean): void {
  const restoredKey = useRef<string | null>(null);

  useLayoutEffect(() => {
    if (!isReady) return;
    if (restoredKey.current === scrollKey) return;
    const saved = readHomeScroll(scrollKey);
    if (saved !== null) {
      window.scrollTo({ top: saved, behavior: 'auto' });
      clearHomeScroll(scrollKey);
    }
    restoredKey.current = scrollKey;
  }, [isReady, scrollKey]);
}
